module.exports = __webpack_public_path__ + "img/文字版_00.0e3aacd7.png";